module.exports = __webpack_public_path__ + "img/star-2.837a77a5.svg";